"use client";

import { forwardRef } from "react";

import { FormInput } from "@/components/input/formInput.component";
import { InputProps } from "@/components/input/input.component";

export const PhoneInput = forwardRef<HTMLInputElement, InputProps>(
  function PhoneInput({ onInput, ...props }, ref) {
    const handleInput: React.InputEventHandler<HTMLInputElement> = (e) => {
      e.currentTarget.value = formatUsPhoneNumber(e.currentTarget.value);
      onInput?.(e);
    };

    return (
      <FormInput
        ref={ref}
        type="tel"
        autoComplete="tel-national"
        inputMode="numeric"
        placeholder="(555) 123-4567"
        maxLength={14}
        pattern="\(\d{3}\)\s\d{3}-\d{4}"
        onInput={handleInput}
        {...props}
      />
    );
  },
);

export const formatUsPhoneNumber = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);

  if (digits.length <= 3) return digits;
  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};
